import { IntegrationsCapabilityModeEnum } from 'generated/resources/graphql'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const CAPABILITY_MODE_API: IntegrationsCapabilityModeEnum = 'api'
export const CAPABILITY_MODE_FILE: IntegrationsCapabilityModeEnum = 'file'

export const useIsExportMode = (): boolean => {
  const { capabilityMode } = useIntegrationsSyncContext()
  return capabilityMode === CAPABILITY_MODE_FILE
}
